const IMPORT_TYPES = {
  insert: 'insert',
  update: 'update',
  upsert: 'upsert',
  delete: 'delete',
}

export default IMPORT_TYPES
